(function () {

  const EXTERNAL_ENDPOINT = 'https://api.theidealcollective.com/api/entries/cart/calculate';

  async function updateCartEntries(root) {

    console.log(`Updating cart entries: ${new Date().toLocaleTimeString("en-US", { hour12: false })}`);
    
    // Get the validation token.
    const validationEl = root.querySelector("div.giveaways-cart-validation");
    const validationToken = validationEl?.dataset.token;

    // Get the cart data elements.
    const cartDataEl = root.querySelector("div.giveaways-cart-data");
    const cartItemDataEls = root.querySelectorAll("div.giveaways-cart-item-data");

    // Create the cart input.
    const input = buildCartInput(cartDataEl, cartItemDataEls);

    // Send it.
    const response = await calculateCartEntries(validationToken, input);

    // NOTE: The displayed entry values (line item badges, bonus tables and the cart
    // total) are calculated in Liquid from the Shared Sweeps metafields, so they are
    // deliberately not overwritten here. This call still runs to produce the entry
    // attributes carried through to checkout.

    // Update the inputs.
    setElementsValue(root, "input.giveaways-entries-schema", response.Schema);
    setElementsValue(root, "input.giveaways-entries-cart", response.Signature);
    setElementsValue(root, "input.giveaways-entries-result", JSON.stringify(response.Result));
    setElementsValue(root, "input.giveaways-entries-input", JSON.stringify(response.Input));

  }

  function buildCartInput(
    cartDataEl,
    itemEls) {

    // Customer ID and discount codes.
    const customerId = cartDataEl?.dataset.customerId;
    const discountCodes = JSON.parse(cartDataEl?.dataset.discountCodes) || [];

    // Line items.
    const lineItems = Array.from(itemEls).map(el => ({
      ProductId: Number(el.dataset.productId),
      ProductVariantId: Number(el.dataset.variantId),
      Quantity: Number(el.dataset.quantity),
      PurchasePrice: Number(el.dataset.purchasePrice)
    }))
    // optional: remove items with invalid numbers
    .filter(item =>
      Number.isFinite(item.ProductId) &&
      Number.isFinite(item.ProductVariantId) &&
      Number.isFinite(item.Quantity) &&
      Number.isFinite(item.PurchasePrice) &&
      item.Quantity > 0
    );

    return {
      CustomerId: customerId === "" ? null : Number(customerId),
      LineItems: lineItems,
      DiscountCodes: discountCodes,
    };
  }

  async function calculateCartEntries(validationToken, input) {
    
    const result = await fetch(EXTERNAL_ENDPOINT, {
      method: 'POST',
      headers: { 
        'Authorization': `CVT ${validationToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(input),
    });

    if (!result.ok) 
      throw new Error(`External API error (${result.status})`);

    return result.json().catch(() => ({}));
  }

  function setElementsValue(root, selector, value) {

    const els = root.querySelectorAll(selector);
    for (const el of els) {
      el.value = value;
    }
  }

  function setElementsTextContent(root, selector, text) {
    
    const els = root.querySelectorAll(selector);
    for (const el of els) {
      el.textContent = text;
    }
  }

  // Determine where we're going to update/observe cart entries -- this will be either
  // the cart page or the cart drawer.
  //
  // If we're on the cart page, observe cart item changes and recalculate entries when necessary.
  const main = document.querySelector("main");
  if (main && document.querySelector("cart-items")) {
    
    const cartObserver = new MutationObserver((mutations) => {
      console.log("Mutations", mutations);
      for (const mutation of mutations) {
        if (mutation.type === "childList" && mutation.target.id === "cart-live-region-text") {
          updateCartEntries(main);
        }
      }
    });

    cartObserver.observe(main, {
      childList: true,
      subtree: true,
      characterData: true
    });

    updateCartEntries(main);
  }
  // Else we're updating the cart drawer.
  else {

      const cartDrawer = document.getElementById("CartDrawer");
      const cartDrawerObserver = new MutationObserver((mutations) => {
        //console.log("Mutations", mutations);
        for (const mutation of mutations) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'CART-DRAWER-ITEMS') {
                  updateCartEntries(cartDrawer);
              }
            });
          }
        }
      });

      cartDrawerObserver.observe(cartDrawer, {
        childList: true,
        subtree: true,
        characterData: true
      });

    updateCartEntries(cartDrawer);
  }

})();